module.exports = __webpack_public_path__ + "img/a34f54c.png";